import axios from "axios";

export default {
  async getAssignedToList(role_kind = 'indonesia_ptsi_worker') {
    return axios
      .get(`/adminuserListByRole/${role_kind}`, {
        baseURL: localStorage.getItem('CF_BASE_URL') || process.env.VUE_APP_BASE_URL,
      })
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },

  async getExporterList() {
    return axios
      .get("/adminuserListByRole/dds_exporter", {
        baseURL: localStorage.getItem('CF_BASE_URL') || process.env.VUE_APP_BASE_URL,
      })
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },

  async getExporters() {
    return axios
      .get("/exporters", {
         baseURL: localStorage.getItem('CF_BASE_URL') || process.env.VUE_APP_BASE_URL,
      })
      .then(({ data }) => data)
      .catch(({ response }) => Promise.reject(response));
  },
};